import { GameId } from '@bg-shared/enums/GameId';
import {
    LAST_RESULT_CHANNEL_PREFIX,
    LAST_RESULTS_CHANNEL_PREFIX,
    LAST_RESULTS_V2_GAMES_LIST,
    LAST_RESULTS_CHANNEL_PREFIX_V2,
} from '@bg-shared/constants/socketChannels';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { ILastListResultsResponse, ILastResultsResponse } from './interfaces';

export default class LastResultsApi {
    public getLastResults(
        gameId: GameId,
    ): Promise<ILastResultsResponse[] | ILastListResultsResponse> {
        return new Promise((resolve) => {
            webSocketsRepository.emitLast<ILastResultsResponse[] | ILastListResultsResponse>(
                `${
                    LAST_RESULTS_V2_GAMES_LIST.includes(gameId)
                        ? LAST_RESULTS_CHANNEL_PREFIX_V2
                        : LAST_RESULTS_CHANNEL_PREFIX
                }${gameId}`,
                resolve,
            );
        });
    }

    public subscribeLastResult(
        gameId: GameId,
        callback: ICallback<ILastResultsResponse>,
    ): () => void {
        return webSocketsRepository.on<ILastResultsResponse>(
            `${LAST_RESULT_CHANNEL_PREFIX}${gameId}`,
            callback,
        );
    }
}

export const lastResultsApi = new LastResultsApi();
